








































































































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import BaseDialog from '@/utils/dialog-control'
import $Api from '@api'
import { translate } from '@/utils/filters'
import { empty } from 'rxjs'
import { cardValidMap, cardStatusMap, cardMap } from '@/utils/status-map'
import { Bank, Merchant } from '@/api/model/channel'

@Component
export default class BankCardDialog extends BaseDialog {
    form = {
        realName: '',
        phone: '',
        identity: '',
        cardNo: '',
        type: '', // 下拉框
        status: '', // 下拉框
        merchantId: '',
        bankId: '', // 下拉框
        valid: '', // 下拉框
        idType: '',
        id: '',
        firstName: '',
        lastName: '',
        eMail: '',
        expirationYear: '',
        expirationMonth: '',
        cvv2: '',
        syncMember: '',
        ifscCode: ''
    }
    rules = {
        merchantId: {
            trigger: 'change',
            required: true,
            message: translate('channel.merchantNoNull')
        },
        bankId: { required: true, message: translate('bank.bankNameNoNull'), trigger: 'change' },
        // firstName: {required: true, message: translate("bank.firstNameCannot be empty"), trigger: 'change' },
        realName: { required: true, message: translate('bank.realNameCannot be empty'), trigger: 'change' },
        // lastName: {required: true, message: translate("bank.lastNameCannot be empty"), trigger: 'change' },
        phone: { required: true, message: translate('bank.phoneNoNull'), trigger: 'change' },
        identity: {
            trigger: 'change',
            required: true,
            message: translate('bankCardManage.identityNoNull')
        },
        cardNo: { required: true, message: translate('bankCardManage.cardNumNoNull'), trigger: 'change' },
        status: { required: true, message: translate('status.NameNoNull'), trigger: 'change' }
        // cvv2: {required: true, message: translate("bankCardManage.cvv2Cannot be empty"), trigger: 'change' }
    };
    banks: Bank[] = [];
    merchants: Merchant[] = [];
    statusMap = cardStatusMap.createArray();
    validMap = cardValidMap.createArray();
    cardMap = cardMap.createArray();

    change(e: any) {
        console.log(e)
    }

    async querySearch(queryString: any, cb: Function) {
        queryString += ''
        let results = queryString ? this.banks.filter(this.createFilter(queryString)) : this.banks
        cb(results)
    }

    createFilter(queryString: any) {
        return (restaurant: any) => {
            return (restaurant.bankName.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
    }

    async handleSelect(bank: any) {
        $Api.channelService
            .queryAbroadBankById(bank.id)
            .subscribe(bankDetail => {
                for (let formKey in this.form) {
                    this.form[formKey] = formKey !== 'id' && bankDetail[formKey] !== undefined ? bankDetail[formKey] : this.form[formKey]
                }
            })
    }

    public update() {
        return $Api.bankCardService.updateBankCard(this.form)
    }

    public create() {
        return $Api.bankCardService.addBankCard(this.form)
    }

    public onOpen() {
        this.loadData()
    }

    onClose() {

    }

    private async loadData() {
        $Api.channelService.queryAbroadBankDropdown().subscribe(data => {
            this.banks = data
        })
        $Api.channelService.queryMerchantDropdownByUser().subscribe(data => {
            this.merchants = data
        })
    }
}
